import IndexPage, { getServerSideProps as gSP } from 'components/IndexPage';

export default IndexPage;

export const getServerSideProps = gSP;
